import React from 'react'
import { inject, observer } from 'mobx-react'
import classnames from 'classnames'
import EmptyTargetGroupAnalysis from 'stores/EmptyTargetGroupAnalysis'
import EmptyTargetGroupAnalysisView from './EmptyTargetGroupAnalysisView'
import ProcessingTargetGroupAnalysis from 'stores/ProcessingTargetGroupAnalysis'
import ProcessingTargetGroupAnalysisView from './ProcessingTargetGroupAnalysisView'
import RegionAnalysis from 'stores/RegionAnalysis'
import RegionAnalysisView from './RegionAnalysisView'
// This container is always rendered, but renders e.g. a chart,
// an error, or nothing depending on the state of the selection
const AnalysisContainer = ({ selectionStore, uiStore }) => {
  const item = selectionStore.item
  let analysisContent
  if (!item || item.analysis === undefined || selectionStore.isEditing) {
    analysisContent = null
  } else if (item.analysis instanceof RegionAnalysis) {
    analysisContent = <RegionAnalysisView />
  } else if (item.analysis instanceof ProcessingTargetGroupAnalysis) {
    analysisContent = <ProcessingTargetGroupAnalysisView />
  } else if (item.analysis instanceof EmptyTargetGroupAnalysis) {
    analysisContent = <EmptyTargetGroupAnalysisView />
  }
  return (
    <div className={classnames({ 'analysis-section': true, 'analysis-section--squished': uiStore.isPOIMenuExpanded })}>
      {analysisContent}
    </div>
  )
}
export default inject('selectionStore', 'uiStore')(
  observer(AnalysisContainer)
)
